import { useCallback } from "react";
import { api } from "../api/api";
import { filtersInitialState } from "./useFilters";

export const useApi = () => {

    const getSubrubros = useCallback(async (rubroId) => {
        const response = await api.get(`/fe/subrubros?rubroId=${rubroId}`);
        return response.data;
    }, []);

    const getRubros = useCallback(async () => {
        const response = await api.get("/fe/rubros");
        const data = Array.isArray(response.data) ? response.data : response.data.data;
        if (!Array.isArray(data)) return [];

        const rubros = await Promise.all(
            data.map(async (rubro) => {
                const subrubros = await getSubrubros(rubro.id);
                return {
                    ...rubro,
                    subrubros: Array.isArray(subrubros) ? subrubros : []
                };
            })
        );
        return rubros;
    }, [getSubrubros]);

    const getArticulos = useCallback(async (filters = filtersInitialState, limit = 9, offset = 0) => {
        const response = await api.get(`/fe/articulosweb`, {
            params: { ...filters, offset, limit }
        });
        return response.data;
    }, []);

    const getArticulo = useCallback(async (slug) => {
        const response = await api.get(`/fe/articulo/slug/${slug}`);
        return response.data;
    }, []);

    const getArticuloImage = useCallback(async (id, imageId = 0) => {
        const response = await api.get(`/articulo/${id}/imagen?imageId=${imageId}`, { 
            responseType: "blob" 
        });
        return response.data;
    }, []);

    return {
        getRubros,
        getArticulos,
        getArticulo,
        getArticuloImage
    };
};